export function RepEventMenu(mname) {
	if (typeof mname === 'number') mname = mname.toString();
	let el = document.getElementById(mname);
	for (let i = 0; i < 5; i++) {
		let el2 = document.getElementById(i.toString());
		if (el !== el2) {
			el2.style.display = "none";
			document.getElementById("b" + i).checked = false;
		}
	}
	el.style.display = "";
	if (mname === '0') document.getElementById('repRange').style.display = 'none';
	else document.getElementById('repRange').style.display = '';
	document.getElementById("b" + mname).checked = true;
}
